import { SyntheticEvent } from "react";
import { LatLngTuple } from "leaflet";
import imageCompression from 'browser-image-compression';
// External Imports ----------------------------------------------------
import { FixedSizeList as List } from "react-window";
import OriginSelect from "react-select";
import axios, { ResponseType, GenericAbortSignal } from "axios";
import heic2any from "heic2any";
//Internal Imports -----------------------------------------------------
import { useAuthStore } from "src/components/main/authStore";
import locating from "src/img/maps/locating.png";
import potholing from "src/img/maps/potholing.png";
import GRP from "src/img/maps/GPR.png";
import cctvimg from "src/img/maps/cctv.png";
import mappingimg from "src/img/maps/mapping.png";
import tcimg from "src/img/maps/tc.png";
import { json, jsonArr, simple, ss } from "./types";
import { useModalStore } from "../main/modalStore";
import { redirect } from "react-router-dom";
// Constants -----------------------------------------------------
export const appTitle = "Construct Smarter";
export const isDevMode = process.env.NODE_ENV === "development";
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL ?? "https://api0.constructsmarter.com/test/").replace(/\/?$/, "/");
export const regionOptions = [
    "North California", 
    "South California", 
    "Arizona"
];
export const pipelineOptions = {
    "Locating Project": [
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Potholing Project": [
        "Traffic Control Plans", 
        "Permits", 
        "USA Delineation", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "GPR Concrete Scanning and Coring Project": [
        "Work In Progress", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "CCTV Project": [
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Mapping Project": [
        "Work In Progress", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Traffic Control Project": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Hydrovac Excavation Project": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Saw Cutting Project": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ], 
    "Straight Vacuum Service": [
        "Traffic Control Plans", 
        "Permits", 
        "Schedule Field Work", 
        "Work In Progress", 
        "Report Deliverable", 
        "Invoice", 
        "Progress Payment", 
        "Received Payment"
    ]
}
export const subPipelineOptions = {
    "CCTV Project": [
        "NASSCO",
        "LOCATE" 
    ]
}
export const projectCategoryColorCode = {
    "Potholing Project": {rgb: [158, 105, 175], title: "Potholing", icon: potholing}, 
    "Locating Project": {rgb: [244, 81, 30], title: "Locating", icon: locating}, 
    "Mapping Project": {rgb: [142, 36, 170], title: "Mapping", icon: mappingimg}, 
    "CCTV Project": {rgb: [63, 81, 181], title: "CCTV", icon: cctvimg}, 
    "GPR Concrete Scanning and Coring Project": {rgb: [213, 0, 0], title: "GPR Concrete Scanning and Coring", icon: GRP}, 
    "Traffic Control Project": {rgb: [246, 191, 38], title: "Traffic Control", icon: tcimg},
    "Hydrovac Excavation Project": {rgb: [191, 246, 38], title: "HydroVac", icon: tcimg}, 
    "Saw Cutting Project": {rgb: [128, 128, 128], title: "Saw Cutting", icon: tcimg}, 
    "Straight Vacuum Service": {rgb: [128, 64, 128], title: "Straight Vacuum", icon: tcimg}
};
export const fileSystemSchemaForProjects = [
    {"name": "contracts", "title": "Contracts", "folderIdLabel": "contractsFolderId", "folderKey": "contractsFiles"},
    {"name": "emailRecords", "title": "Email Records", "folderIdLabel": "emailRecordsFolderId", "folderKey": "emailRecordsFiles"},
    {"name": "otherAttachments", "title": "Other Documents (Any Important Job Related Documents)", "folderIdLabel": "otherAttachmentsFolderId", "folderKey": "otherAttachmentsFiles"},
    {"name": "techniciansAttachments", "title": "Dispatch Documents (Exhibits, Traffic Plans, USA Tickets) (Visible To All Of This Project Techs)", "folderIdLabel": "techAttachmentsFolderId", "folderKey": "techFiles"}
];
export const poApproverMap = {
    "Outside Service Expense": "armando@besstestlab.com"
};
export const paymentMethodList = [
    "Pay by American Express card", 
    "Pay by company account",
    "Pay by personal account",
    "Pay by Mastercard 5872", 
    "Pay by Costco Visa Card"
]
export const additionalJobTagApproverEmails = [];
export const defaultPOApproverEmail = "michael@besstestlab.com";
export const defaultEmptyDate = "0000-00-00";
export const defaultEmptyDateTime = "0000-00-00 00:00:00";
export const defaultEmptyTime = "00:00:00";
export const defaultEmptyPMNumber = "00000000";
export const outsideWorkingOns = [
    "PGE 1st Party Locate", 
    "PGE 2nd Party Locate", 
    "PGE 1st Party Standby", 
    "PGE 2nd Party Standby", 
    "3rd Party Standby", 
    "Running a self populated folder", 
    "Training"
];
export const testerEmails = [
    "jun909l@yahoo.com"
];
export const outsideNotWorkingReasons = [
    "No Work", 
    "Sick",
    "Injured", 
    "Training", 
    "Vacation"
];
export const jsaManagers = [
    {name: "Joshua Daneker", email: "jdaneker@besstestlab.com", tel: "510-825-1025"},
];
export const jsaOnsiteNumbers = [
    "866-523-8046"
];
export const outsideCordinators = [];
export const locatingReportWriterEmails = [];
export const potholingReportWriterEmails = [];
export const CCTVReportWriterEmails = [];
export const reportWriterIds: any[] = [
    ...locatingReportWriterEmails, 
    ...potholingReportWriterEmails, 
    ...CCTVReportWriterEmails
];
export const standbyExceptionEmails = [];
export const billingManagerEmails = [];
export const billingMemberEmails = [];
export const billingEmails = [
    ...billingManagerEmails, 
    ...billingMemberEmails
];
export const laborCostUploaderEmailList = [];
export const BillingUploaderEmailList = [];
export const runnerExceptionEmailList = [];
export const locatorExceptionsList = [];
export const outsideStatusExceptions = [];
export const exclusiveOutisdeKeys = [
    "email", 
    "lanId", 
    "hireDate",
    "quitDate", 
    "outside", 
    "userName", 
    "residenceState", 
    "residence", 
    "street", 
    "zipCode", 
    "phoneNumber", 
    "firstName",
    "lastName"
];
export const LMStatusOpts = {
    Ongoing: [
        "Work Ongoing", 
        "Electrical Hook Up Points", 
        "Phase Ticket", 
        "Negotiate New Start", 
        "No Delineation (Ongoing)", 
        "Excavated Before Marked (Ongoing)", 
        "Attempted to Contact Excavator"
    ],
    Complete: [
        "Facilities Marked", 
        "No Conflict", 
        "No Conflict (Screened)", 
        "No Delineation (Complete)", 
        "No Excavation to Take Place", 
        "No Remark Required", 
        "Located by PG&E Crew", 
        "Bad Ticket Info", 
        "Excavated Before Marked", 
        "No Access to Delineated Area (0/3)"
    ]
};
export const weekDays = [
    "Monday", 
    "Tuesday", 
    "Wednesday", 
    "Thursday", 
    "Friday", 
    "Saturday", 
    "Sunday", 
];
export const month = [
    "January", 
    "February", 
    "March", 
    "April", 
    "May", 
    "June", 
    "July", 
    "August", 
    "September", 
    "October", 
    "November", 
    "December"
];
export const mon = [
    "Jan", 
    "Feb", 
    "Mar", 
    "Apr", 
    "May", 
    "Jun", 
    "Jul",
    "Aug", 
    "Sep", 
    "Oct", 
    "Nov", 
    "Dec"
];
export const defaultEmptyLocatorDataString = JSON.stringify({
    "form": Array(7).fill({
        "data": [], 
        "status": "Created", 
        "overnight": false
    })
});
export const emailsListFor1245Exception5x8 = [];
export const pmEmails = [];
interface mimeTypeMapType {
    "txt": "text/plain", 
    "xml": "text/xml",
    "kml": "application/vnd.google-earth.kml+xml", 
    "pdf": "application/pdf", 
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
    "xlsm": "application/vnd.ms-excel.sheet.macroenabled.12", 
    "xls": "application/vnd.ms-excel", 
    "csv": "text/csv", 
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
    "xps": "application/vnd.ms-xpsdocument", 
    "docm": "application/vnd.ms-word.document.macroenabled.12", 
    "doc": "application/msword", 
    "accdb": "application/msaccess", 
    "msg": "application/vnd.ms-outlook", 
    "rtf": "application/rtf", 
    "png": "image/png", 
    "jpg": "image/jpeg", 
    "jpeg": "image/jpeg", 
    "svg": "image/svg+xml", 
    "gif": "image/gif", 
    "bmp": "image/bmp", 
    "mp3": "audio/mpeg", 
    "mp4": "video/mp4", 
    "zip": "application/x-zip-compressed", 
    "json": "application/json",
    "folder": "application/vnd.google-apps.folder",
    "document": "application/vnd.google-apps.document"
}
export const mimeTypeMap: mimeTypeMapType = {
    "txt": "text/plain", 
    "xml": "text/xml",
    "kml": "application/vnd.google-earth.kml+xml", 
    "pdf": "application/pdf", 
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
    "xlsm": "application/vnd.ms-excel.sheet.macroenabled.12", 
    "xls": "application/vnd.ms-excel", 
    "csv": "text/csv", 
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
    "xps": "application/vnd.ms-xpsdocument", 
    "docm": "application/vnd.ms-word.document.macroenabled.12", 
    "doc": "application/msword", 
    "accdb": "application/msaccess", 
    "msg": "application/vnd.ms-outlook", 
    "rtf": "application/rtf", 
    "png": "image/png", 
    "jpg": "image/jpeg", 
    "jpeg": "image/jpeg", 
    "svg": "image/svg+xml", 
    "gif": "image/gif", 
    "bmp": "image/bmp", 
    "mp3": "audio/mpeg", 
    "mp4": "video/mp4", 
    "zip": "application/x-zip-compressed", 
    "json": "application/json",
    "folder": "application/vnd.google-apps.folder",
    "document": "application/vnd.google-apps.document"
};
export const mimeTypeMapReverse  = Object.fromEntries(Object.entries(mimeTypeMap).map(([key, value]) => [value, key]));
export const outsideRoleCode = {
    "locator": "CURRENT PG&E Locate & Mark/USAs", 
    "standby": "Gas Standby", 
    "qew": "Qualified Electrical Worker (QEW)"
};
export const simpleStatusColorCode = {
    "Not Created": "gray",
    "Created": "red", 
    "Saved": "orange",
    "Submitted": "purple", 
    "Re-Submitted": "black", 
    "Approved": "green",
    "Rejected": "gray",
    "Completed": "green"
};
export const simpleStatusColorCodExcelHex = {
    "Created": "FF0000", 
    "Submitted": "800080", 
    "Approved": "00FF00",
    "Rejected": "808080"
};
export const locatingApproval = []; // emails of people who can approve locating reports
export const scanningApproval = []; // emails of people who can approve scanning reports
export const OfficesLocationMap:{
    [key: string]: LatLngTuple 
} = {
    "Hayward Office": [37.61498, -122.08525], // 2463 Tripaldi Way, Hayward, CA 94545
    "Sacramento Office": [38.52465, -121.39588], // 18 Business Park Way, Sacramento, CA 95828
    "Fresno Office": [36.79860, -119.85823], // 4284 N Knoll Ave., Fresno, CA 93722
    "Ontario Office": [34.041040, -117.619390], // 1508 E Francis St, Ontario, CA 91761
    "Fremont Yard": [37.496590, -121.929090] // 801 Boggs Ave., Fremont, CA 94539
}
export const isMobilePhone = (navigator as json).userAgentData?.mobile ?? ((navigator.userAgent.toLowerCase().search("mac") > -1) || (navigator.userAgent.toLowerCase().search("iphone") > -1) || (navigator.userAgent.toLowerCase().search("android") > -1));
export const localWeekDays = [...weekDays.slice(4), ...weekDays.slice(0, 4)];
export const validateEmail = (email:string) => {
    return email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
// Class -----------------------------------------------------
export class MyDate extends Date{
    s(){
        return this.toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"});
    }
    ss(){
        return this.toLocaleTimeString("En-US", {timeZone: "America/Los_Angeles"});
    }
};
export class MyFormData extends FormData {
    constructor(args?: HTMLFormElement){
        super(args);
        for(let pair of this.entries()){
            if(typeof(pair[1]) === "string"){
                this.set(pair[0], pair[1].trim());
            }
        }
    }
};
// Functions -----------------------------------------------------
// one-liner
export const calculateDistance = (lat: number, lng: number, center: number[]) => (Math.sqrt(Math.pow((lat - center[0]) * 69, 2) + Math.pow((lng - center[1]) * 54.6, 2)));
export const payRollRuleChangeDate = (date: Date) => (new Date(date.getFullYear() + "/3/31")) < date && date < (new Date(date.getFullYear() + "/11/15"));
export const round = (e: string | number, i: number = 0) => window.Number.parseFloat((typeof(e) === "string"?window.Number.parseFloat(e):e).toFixed(i));
export const onlyUnique = (value: simple, index: number, self: simple[]) => (value !== 0 && !value)?false:(self.indexOf(value) === index);
export const ascSort = (a: simple, b: simple) => a! > b!? 1 : -1;
export const descSort = (a: simple, b: simple) => a! < b!? 1 : -1;
export const objAscSort = (a: json, b: json, sortParameter: string, options?: {caseInsensitive: boolean}) => options?.caseInsensitive?(a[sortParameter]?.toLowerCase() > b[sortParameter]?.toLowerCase()? 1 : -1):(a[sortParameter] > b[sortParameter]? 1 : -1);
export const objDescSort = (a: json, b: json, sortParameter: string, options?: {caseInsensitive: boolean}) => options?.caseInsensitive?(a[sortParameter]?.toLowerCase() < b[sortParameter]?.toLowerCase()? 1 : -1):(a[sortParameter] < b[sortParameter]? 1 : -1);
export const boolOrReducer = (accumulator: boolean, currentValue: boolean) => accumulator || currentValue;
export const boolAndReducer = (accumulator: boolean, currentValue: boolean) => accumulator && currentValue;
export const numberReducer = (accumulator: number, currentValue: number) => accumulator + currentValue;
export const arrayReducer = (accumulator: any[], currentValue: any[]) => [...accumulator, ...currentValue];
export const objectReducer = (accumulator: json, currentValue: json) => ({...accumulator, ...currentValue});
export const toProperCase = (str: string) => str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
// normal
export const test = (e:any) => {
    if(isDevMode) console.log(e);
    return e;
}
export const convertNumbersToLetters = (number:number) => {
    const dict = "ZABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let n = number;
    let s = "";
    while(n > 26){
      const m = n % 26;
      s = dict[m] + s;
      n = Math.floor(n / 26);
      if(m === 0) n--;
    }
    return dict[n] + s;
}
export const convertAMPM = (str: string) => {
    if(!str) return str;
    // 6:05:06 PM
    const x = str.slice(-2);
    if(x === "AM" || str.startsWith("12")){
        if(str[1] === ":") return "0" + str.slice(0, -3);
        return str.slice(0, -3);
    }else{
        const timeArr = str.split(":");
        const h = window.parseInt(timeArr[0]) + 12;
        const m = timeArr[1];
        const s = timeArr[2].slice(0, 2);
        return `${h}:${m}:${s}`;
    }
}
export const convert24 = (str: string) => {
    if(!str) return str;
    // 06:05:06
    const timeArr = str.split(":");
    const h = window.parseInt(timeArr[0]);
    const m =timeArr[1];
    const s = timeArr[2];
    if(h < 12) return `${h}:${m}:${s} AM`;
    if(h === 12) return `12:${m}:${s} PM`;
    const realH = h - 12;
    return `${realH}:${m}:${s} PM`;
}
export const isDstObserved = (date: Date) => { // unused
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    return date.getTimezoneOffset() < stdTimezoneOffset;
}
export const addDate = (dateString: string, num: number) => {
    if(
        !dateString ||
        dateString === defaultEmptyDate || 
        dateString === defaultEmptyDate.replace(/-/g,"/")
    ) return "";
    const date = new MyDate(dateString.replace(/-/g,"/"));
    date.setDate(date.getDate() + num);
    return date.s();
}
export const usaExpireColorCode = (e: string) => {
    if(e === "") return "";
    const date = new Date(e);
    if(date < new Date()) return "red";
    date.setDate(date.getDate() - 14);
    if(date < new Date()) return "yellow";
    return "rgba(4,170,109,0.8)";
    
}
export const showSize = (number: number) => {
    let n = number;
    if(n < 1024){return n;}
    n = round(String(n / 1024), 2);
    if(n < 1024){return n + " K";}
    n = round(String(n / 1024), 2);
    if(n < 1024){return n + "M";}
    n = round(String(n / 1024), 2);
    if(n < 1024){return n + "G";}
}


    // const token = useAuthStore(state => state.token);
   //  const setToken = useAuthStore(state => state.setToken);
export const myAxios = async(
{
    fileName, 
    formData, 
    responseType, 
    signal,
    redirectPath
}:
{
    fileName: string, 
    formData?: FormData, 
    responseType?: ResponseType, 
    signal?: GenericAbortSignal,
    redirectPath?: string,
}
) => {
    const normalizedFileName = fileName.replace(/^\/+/, "");
    const shouldAttachTokenHeaders = normalizedFileName !== "auth/refresh.php";
    const api = axios.create({
        baseURL: API_BASE_URL,
        withCredentials: true,
        timeout: 30000,
    })
    api.interceptors.request.use(
        config => {
            if (!navigator.onLine) {
                return Promise.reject(new Error("OFFLINE"));
            }
            const token = useAuthStore.getState().token;
            if (token && shouldAttachTokenHeaders) {
                config.headers = config.headers ?? {};
                config.headers.Authorization = token;
                config.headers["X-App-Token"] = token;
            }
            return config;
        },
        error => Promise.reject(error)
    );
    api.interceptors.response.use(
        res => {
            const nextToken =
                res.headers["x-auth-token"] ??
                res.headers["authorization"] ??
                res.data?.token;
            if (typeof nextToken === "string" && nextToken.trim()) {
                useAuthStore.getState().setToken(nextToken.trim());
            }
            return res;
        },
        async err => {
            if (axios.isCancel(err) || err.message === "canceled") {
                return Promise.reject({ silent: true });
            }
            if (err.response) { 
                const contentType = err.response.headers["content-type"] ?? "";
                if (contentType.includes("application/json") && err.response.data instanceof Blob) {
                    try {
                        const text = await err.response.data.text();
                        err.response.data = JSON.parse(text);
                    } catch {
                        // leave data as-is if parsing fails
                    }
                }
                const status = err.response.status;
                if((status !== 401 && status !== 403) || (status === 404 && !redirectPath)){
                    useModalStore.getState().showModal({
                        title: err.response.data.title ?? "Error",  
                        message: err.response.data.msg ?? (status === 500? "Internal Error" : ""),
                    });
                }
                if (status === 401 || status === 403) {
                    const from = window.location.pathname + window.location.search;
                    useAuthStore.getState().clearToken();
                    if(useAuthStore.getState().isAuthenticated){
                        useModalStore.getState().showModal({
                            title: err.response.data.title ?? "Error",  
                            message: err.response.data.msg ?? (status === 500? "Internal Error" : ""),
                            onConfirm: () => { 
                                setFromOnce(from);
                                window.location.href = "/Login";
                            }
                        });
                    }else{
                        setFromOnce(from);
                        window.location.href = "/Login";
                    }
                }
                if(status === 404 && redirectPath){
                    useModalStore.getState().showModal({
                        title: err.response.data.title ?? "Error",  
                        message: err.response.data.msg ?? (status === 500? "Internal Error" : ""),
                        onConfirm: () => {throw redirect(redirectPath);}
                    });
                }
                return false;
            }
            return Promise.reject(new Error("NETWORK_ERROR"));
        }
    );
    const data = formData ?? new FormData();
    const token = useAuthStore.getState().token;
    if (token && shouldAttachTokenHeaders && !data.has("token")) {
        data.append("token", token);
    }
    return api.post(normalizedFileName, data, {
        responseType,
        signal,
    });
}
const FROM_KEY = "auth:from";
export function setFromOnce(from: string) {
  if (!sessionStorage.getItem(FROM_KEY)) {
    sessionStorage.setItem(FROM_KEY, from);
  }
}
export function consumeFrom(): string {
  const from = sessionStorage.getItem(FROM_KEY) ?? "/";
  sessionStorage.removeItem(FROM_KEY);
  return from;
}
export const post_max_size = 8 * 1024 * 1024; // PHP_INI_PERDIR
export const handleFilesInput = (e: SyntheticEvent) => {
    const event = e.nativeEvent;
    const target = event.target as HTMLInputElement;
    const files = target.files!;
    if(files.length === 0) return;
    let size = 0;
    if(files.length === 1){
        size = files[0].size;
        if(files[0].size < 100 * 1024){
            if(!window.confirm(`The file size (${(files[0].size / 1024).toFixed(2)}k) is too small (less than 100k). Are you sure to upload?\n(Images can be selected as Medium or Large for better quality.)`)){
                target.value = "";
                return;
            }
        }
    }else if(files.length > 1){
        for(const file of files){
            size += file.size;
            if(file.size < 100 * 1024){
                if(!(window.confirm(`One of the file size (${(file.size / 1024).toFixed(2)}k) is too small (less than 100k). Are you sure to upload?\n(Images can be selected as Medium or Large for better quality.)`)!)){
                    target.value = "";
                    return;
                }
            }
        }
    }
    if(size > post_max_size){
        const upload_size_in_M = round(size / 1024 / 1024, 2);
        const post_max_size_in_M = round(post_max_size / 1024 / 1024);
        if(!window.confirm(`Upload size (${upload_size_in_M}M) exceed max allowable size ${post_max_size_in_M}M. Still Proceed? (This may cause error.)`)){
            target.value = "";
            return;
        }
    }
}
export const addslashes = (str: string | undefined) => {
    if(str === undefined) return "";
    return str.replace(/\\/g, '\\\\')
        .replace(/\t/g, '\\t')
        .replace(/\n/g, '\\n')
        .replace(/\f/g, '\\f')
        .replace(/\r/g, '\\r')
        .replace(/'/g, '\\\'')
        .replace(/"/g, '\\"');
}
export const scroll = (id?: string | null) => {
    if(id === undefined){
        return;
    }else if(id === null){
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    }else{
        const interval = setInterval(() => {
            if(document.getElementById(id)){
                window.setTimeout(() => {
                    document.getElementById(id)?.scrollIntoView({
                        behavior: "smooth", block: "start"
                    });
                }, 200);
            }
        }, 200);
        window.setTimeout(() => {
            clearInterval(interval);
        }, 400);
    }
}
export const getJsonArray = (e: string) => {
    try{
        return JSON.parse(e);
    }catch(error){
        window.alert("System error occurred on your files.");
        return [];
    }
}
export const statusColorCode = (status: string, workStatus?: string) => {
    switch(status){
        case "Created":
            return "red";
        case "Saved":
            return "purple";
        case "Submitted":
            if(workStatus !== undefined && workStatus !== "Work"){
                return "gray"
            }else{
                return "green";
            }
        case "Rejected":
            return "blue";
        default:
            return "black";
    }
}
export const weeknum = (date_string: Date | string) => {
    if(!date_string) return "";
    let res: string;
    if(date_string instanceof MyDate){
        res = date_string.s().replace(/-/g, "/");
    }else if(date_string instanceof Date){
        res = date_string.toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}).replace(/-/g, "/");
    }else{
        res = date_string;
    }
    const target = new Date(res.substring(0, 10).replace(/-/g, "/"));
    const dayNr = (target.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    const firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
        target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }
    const number = 1 + Math.ceil((firstThursday - target.valueOf()) / 604800000);
    const year = target.getFullYear();
    const result = "w" + year + "-" + (number < 10? "0" + number.toString(): number.toString());
    return result;
}
export const changeWeek = (week: string, numberWeeks: number) => {
    const target = getDatefromWeekNum0(week, 1)!;
    target.setDate(target.getDate() + 7 * numberWeeks);
    return weeknum(target);
}
export const getMonthfromWeekNum = (week: string, dayNum: number) => {
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
   return month[(new Date(year, 0, days)).getMonth()];
}
export const getDatefromWeekNum0 = (week: string, dayNum: number) => {
    if(!week) return;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    return new MyDate(year, 0, days);
}
export const getDatefromWeekNum = (week: string, dayNum: number) => {
    if(!week) return;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    return (new MyDate(year, 0, days)).s();
}
export const getDateEndFromWeekNum = (week: string) => {
    if(!week) return;
    const dayNum = 6;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    const date_string = (new MyDate(year, 0, days)).s();
    const newYear = date_string.substring(0, 4);
    const newMonth = date_string.substring(5, 7);
    const newDay = date_string.substring(8, 10);
    return `WE ${newMonth}-${newDay}-${newYear}`;
}
export const getDateEndFromWeekNum2 = (week: string) => {
    if(!week) return;
    const dayNum = 6;
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    const date_string = (new MyDate(year, 0, days)).s();
    const newYear = date_string.substring(0, 4);
    const newMonth = date_string.substring(5, 7);
    const newDay = date_string.substring(8, 10);
    return `${newYear}/${newMonth}/${newDay}`;
}
export const getDateTime = (week: string, dayNum: number, hours: number, minutes: number) => {
    const year = window.Number.parseInt(week.substring(1).split("-")[0]);
    const firstDayOfYear = new Date(year, 0, 1);
    let weeks = window.Number.parseInt(week.substring(1).split("-")[1]) - 1;
    const days = 2 - firstDayOfYear.getDay() + weeks * 7 + dayNum;
    const deadline = new Date(year, 0, days);
    deadline.setHours(hours);
    deadline.setMinutes(minutes);
    return deadline;
}
export const timepicker = (obj?: {unitTime?: number, startIndex: number, timeLength: number}) => {
    let validUnitTime = 15;
    let validStartIndex = 0;
    let validTimeLength = 96;
    const unitTime = obj!?.unitTime ?? validUnitTime;
    const startIndex = obj!?.startIndex;
    const timeLength = obj!?.timeLength;
    if(Number.isInteger(unitTime) && !(60 % unitTime)){
        validUnitTime = unitTime;
    }
    const len = 60 / validUnitTime;
    const h12 = [
        "12", "01", "02", "03", "04", "05", 
        "06", "07", "08", "09", "10", "11"
    ];
    const h24 = [
        "00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", 
        "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"
    ];
    const ampm = ["AM", "PM"];
    const mins = [];
    for(let i = 0; i < len; i++){
        if(i * validUnitTime < 10){
            mins.push(0 + String(i * validUnitTime));
        }else{
            mins.push(String(i * validUnitTime));
        }
    }
    const timepickerArr = [];
    for(let k = 0; k < ampm.length; k++){
        for(let i = 0; i < h12.length; i++){
            for(let j = 0; j < mins.length; j++){
                timepickerArr.push({
                    text:`${h12[i]}:${mins[j]} ${ampm[k]}`, 
                    value:`${h24[k>0?i+12:i]}:${mins[j]}`
                });
            }
        }
    }
    if(Number.isInteger(startIndex)){
        validStartIndex = startIndex;
    }
    if(Number.isInteger(timeLength)){
        validTimeLength = timeLength;
    }
    if(validStartIndex + validTimeLength > 96){
        return [
            ...timepickerArr.slice(validStartIndex, validTimeLength),
            ...timepickerArr.slice(0, validStartIndex + validTimeLength - 96).map(time => ({text: "next day " + time.text, value: "12/31/1899 " + time.value + ":00"}))
        ];
    }else{
        return timepickerArr.slice(validStartIndex, validTimeLength);
    }
}
export const buildWeekNumArray = (start: string, end?: string) => {
    const res = [];
    const min = new Date(start.replace(/-/g, "/"));
    const max = (end && end !== defaultEmptyDate)?new Date(end.replace(/-/g, "/")):new Date();
    while(min < max){
        res.push(weeknum(min));
        min.setDate(min.getDate() + 7);
    }
    if(
        !res.includes(weeknum(max))
    ){
        
        res.push(weeknum(max));
    }
    return res;
}
const getCustomDate = (year: number, month: number, week: number, day: number) => { // internal use
    let firstDay = 1;
    if(week < 0){
        month++;
        firstDay--;
    }
    const date = new MyDate(year, month, (week * 7) + firstDay);
    if(day <= date.getDay()){
        day += 7;
    }
    date.setDate(date.getDate() - date.getDay() + day);
    return date.s();
}
export const dateDurationCalc = (start:string, end:string) => {
    if(start === end) return "1 day"; // easy computation
    const from = new Date(start.replace(/-/g, "/"));
    const to = new Date(end.replace(/-/g, "/"));
    let n = Math.ceil((to.getTime() - from.getTime()) / (1000 * 3600 * 24));
    from.setDate(from.getDate() + n);
    if(from.getDate() !== to.getDate()){
        from.setDate(from.getDate() + 1);
        n++;
        if(from.getDate() !== to.getDate()){
            from.setDate(from.getDate() - 2);
            n -= 2;
        }
    }
    return String(n + 1) + " days";
}
export const timeDurationCalc = (start:string, end:string) => ((new Date(`2021/5/10 ${end}`)).getTime() - (new Date(`2021/5/10 ${start}`)).getTime()) / 60000;
export const getFirstNonLunchIndex = (dayData: {data: any}) => {
    const jobs = dayData.data;
    for(let i = 0; i < jobs.length; i++){
        if(jobs[i].category !== "lunch" && !["02055506", "02051446", defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = 0; i < jobs.length; i++){
        if(jobs[i].category !== "lunch" && ![defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = 0; i < jobs.length; i++){
        if(jobs[i].category !== "lunch"){
            return i;
        }
    }
    return false;
}
export const getLastNonLunchIndex = (dayData: {data: any}) => {
    const jobs = dayData.data;
    for(let i = jobs.length - 1; i >= 0; i--){
        if(jobs[i].category !== "lunch" && !["02055506", "02051446", defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = jobs.length - 1; i >= 0; i--){
        if(jobs[i].category !== "lunch" && ![defaultEmptyPMNumber].includes(jobs[i].pmNumber)){
            return i;
        }
    }
    for(let i = jobs.length - 1; i >= 0; i--){
        if(jobs[i].category !== "lunch"){
            return i;
        }
    }
    return false;
}
const calcMob = (obj: {mobInTime: number, mobOutTime: number, regular: number, ot: number, mobInFrom: string, mobOutTo: string}) => {
    let regular = 0, ot = 0, regular1 = 0, regular2 = 0, ot1 = 0, ot2 = 0;
    const mobIn = round(obj.mobInFrom === "Hotel"?obj.mobInTime / 60 : Math.max(obj.mobInTime - 60, 0) / 60, 2);
    const mobOut = round(obj.mobOutTo === "Hotel"?obj.mobOutTime / 60 : Math.max(obj.mobOutTime - 60, 0) / 60, 2);
    if(mobIn > obj.regular){
        regular += obj.regular;
        regular1 += obj.regular;
        ot += mobIn - obj.regular;
        ot1 += mobIn - obj.regular;
    }else{
        regular += mobIn;
        regular1 += mobIn;
    }
    if(mobOut > obj.ot){
        ot += obj.ot;
        ot2 += obj.ot;
        regular += mobOut - obj.ot;
        regular2 += mobOut - obj.ot;
    }else{
        ot += mobOut;
        ot2 += mobOut;
    }
    return {regular, ot, regular1, regular2, ot1, ot2};
}
const calcStandByTime = (start: string, end: string, AllOT: boolean) => {
    let regular = 0, ot = 0;
    if(AllOT){
        ot = round(timeDurationCalc(start, end) / 60, 2);
    }else{
        if(start <= "07:00" && end <= "07:00"){
            ot = round(timeDurationCalc(start, end) / 60, 2);
        }else if("07:00" <= start && start <= "15:30" && "07:00" <= end && end <= "15:30"){
            regular = round(timeDurationCalc(start, end) / 60, 2);
        }else if(start >= "15:30" && end >= "15:30"){
            ot = round(timeDurationCalc(start, end) / 60, 2);
        }else if(start <= "07:00" && "07:00" <= end && end <= "15:30"){
            ot = round(timeDurationCalc(start, "07:00") / 60, 2);
            regular = round(timeDurationCalc("07:00", end) / 60, 2);
        }else if(start <= "07:00" && end >= "15:30"){
            ot = round(timeDurationCalc(start, "07:00") / 60 + timeDurationCalc(end, "15:30") / 60, 2);
            regular = round(timeDurationCalc("07:00", "15:30") / 60, 2);
        }else if("07:00" <= start && start <= "15:30" && end >= "15:30"){
            regular = round(timeDurationCalc(start, "15:30") / 60, 2);
            ot = round(timeDurationCalc("15:30", end) / 60, 2);
        }else{
            console.log(start, end);
        }
    }
    return { regular, ot };
}
export const calcLocate = (
    curData: {
        data: {
            start: string, 
            end: string, 
            mins: number, 
            category: string, 
            regular: number, 
            ot: number, 
            pmNumber: string
        }[], 
        mobInTime: number, 
        mobInTimeEffective: number, 
        mobInTimePM: string, 
        mobOutTime: number, 
        mobOutTimeEffective: number, 
        mobOutTimePM: string, 
        workTime: number, 
        mobInStart: string, 
        mobInEnd: string, 
        mobOutStart: string, 
        mobOutEnd: string, 
        lunchTime: number, 
        mobInFrom: string, 
        mobOutTo: string, 
        regular: number, 
        ot: number, 
        mobReg: number, 
        mobInReg: number,
        mobOutReg: number,
        mobOT: number, 
        mobInOT: number, 
        mobOutOT: number, 
        workStatus: string, 
        status: string
    }, 
    dayNum: number, 
    dateString: string, 
    outside: string, 
) => {
    let rawData = curData;
    
    const firstNonLunchIndex = getFirstNonLunchIndex(rawData);
    const lastNonLunchIndex = getLastNonLunchIndex(rawData);
    if(firstNonLunchIndex === false) return rawData;
    if(lastNonLunchIndex === false) return rawData;
    if(rawData.workStatus !== "Work") return rawData;
    if(rawData.status !== "Submitted") return rawData;
    const allOT = dayNum > 4 || outsideHolidays(Number(dateString.split("-")[0])).map(h => h.date).includes(dateString);
    if(outside === "locator"){
        rawData.mobInTime = timeDurationCalc(rawData.mobInStart, rawData.mobInEnd);
        rawData.mobInTimePM = rawData.data[firstNonLunchIndex].pmNumber;
        rawData.mobOutTime = timeDurationCalc(rawData.mobOutStart, rawData.mobOutEnd);
        rawData.mobOutTimePM = rawData.data[lastNonLunchIndex].pmNumber;
        rawData.workTime = timeDurationCalc(rawData.mobInEnd, rawData.mobOutStart);
        rawData.data = rawData.data.map(d => ({...d, mins: timeDurationCalc(d.start, d.end)}));
        if(rawData.data.find(d => d.category === "lunch")){
            rawData.lunchTime = rawData.data
            .filter(d => d.category === "lunch")
            .reduce((a, b) => ({mins:(a.mins + b.mins)}), {mins: 0}).mins;
            rawData.workTime -= rawData.lunchTime;
        }else{
            rawData.lunchTime = 0;
        }
        if(rawData.mobInFrom === "Hotel"){
            // rawData.data[firstNonLunchIndex].mins += rawData.mobInTime;
            rawData.workTime += rawData.mobInTime;
        }else{
            if(rawData.mobInTime > 60){
                // rawData.data[firstNonLunchIndex].mins += rawData.mobInTime - 60;
                rawData.workTime += rawData.mobInTime - 60;
            }
        }
        if(rawData.mobOutTo === "Hotel"){
            // rawData.data[lastNonLunchIndex].mins += rawData.mobOutTime;
            rawData.workTime += rawData.mobOutTime;
        }else{
            if(rawData.mobOutTime > 60){
                // rawData.data[lastNonLunchIndex].mins += rawData.mobOutTime - 60;
                rawData.workTime += rawData.mobOutTime - 60;
            }
        }
        rawData.regular = 0;
        rawData.ot = 0;
        if(allOT){
            if(rawData.workTime <= 2 * 60){
                rawData.ot = 2;
                rawData.data[lastNonLunchIndex].mins += 2 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 4 * 60){
                rawData.ot = 4;
                rawData.data[lastNonLunchIndex].mins += 4 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 6 * 60){
                rawData.ot = 6;
                rawData.data[lastNonLunchIndex].mins += 6 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 8 * 60){
                rawData.ot = 8;
                rawData.data[lastNonLunchIndex].mins += 8 * 60 - rawData.workTime;
            }else{
                rawData.ot = round(rawData.workTime / 60, 2);
            }
        }else{
            if(rawData.workTime <= 2 * 60){
                rawData.regular = 2;
                rawData.data[lastNonLunchIndex].mins += 2 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 4 * 60){
                rawData.regular = 4;
                rawData.data[lastNonLunchIndex].mins += 4 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 6 * 60){
                rawData.regular = 6;
                rawData.data[lastNonLunchIndex].mins += 6 * 60 - rawData.workTime;
            }else if(rawData.workTime <= 8 * 60){
                rawData.regular = 8;
                rawData.data[lastNonLunchIndex].mins += 8 * 60 - rawData.workTime;
            }else{
                rawData.regular = 8;
                rawData.ot = round(rawData.workTime / 60, 2) - 8;
            }
        }
        const {regular, ot, regular1, regular2, ot1, ot2} = calcMob(rawData);
        rawData.mobReg = regular;
        rawData.mobInReg = regular1;
        rawData.mobOutReg = regular2;
        rawData.mobOT = ot;
        rawData.mobInOT = ot1;
        rawData.mobOutOT = ot2;
        if(Number.isNaN(rawData.ot) || Number.isNaN(rawData.ot)) console.log(rawData);
    }else if(["standby", "qew"].includes(outside)){
        rawData.mobInTime = timeDurationCalc(rawData.mobInStart, rawData.mobInEnd);
        rawData.mobInTimePM = rawData.data[firstNonLunchIndex].pmNumber;
        rawData.mobOutTime = timeDurationCalc(rawData.mobOutStart, rawData.mobOutEnd);
        rawData.mobOutTimePM = rawData.data[lastNonLunchIndex].pmNumber;
        rawData.workTime = timeDurationCalc(rawData.mobInEnd, rawData.mobOutStart);
        rawData.data = rawData.data.map(d => ({...d, mins: timeDurationCalc(d.start, d.end)}));
        if(rawData.data.find(d => d.category === "lunch")){
            rawData.lunchTime = rawData.data
            .filter(d => d.category === "lunch")
            .reduce((a, b) => ({mins:(a.mins + b.mins)}), {mins: 0}).mins;
            rawData.workTime -= rawData.lunchTime;
        }else{
            rawData.lunchTime = 0;
        }
        rawData.workTime += rawData.mobInTime;
        rawData.workTime += rawData.mobOutTime;
        rawData.regular = 0;
        rawData.ot = 0;
        rawData.mobReg = 0;
        rawData.mobOT = 0;
        for(const [index, {start, end, category}] of rawData.data.entries()){
            if(category === "lunch") continue;
            const {regular, ot} = calcStandByTime(start, end, allOT);
            rawData.data[index].regular = regular;
            rawData.data[index].ot = ot;
            rawData.regular += regular;
            rawData.ot += ot;
        }
        const mobInTime = calcStandByTime(rawData.mobInStart, rawData.mobInEnd, allOT);
        const mobOutTime = calcStandByTime(rawData.mobOutStart, rawData.mobOutEnd, allOT);
        rawData.mobInReg = mobInTime.regular;
        rawData.mobReg += mobInTime.regular;
        rawData.regular += mobInTime.regular;
        rawData.mobInOT = mobInTime.ot;
        rawData.mobOT += mobInTime.ot;
        rawData.ot += mobInTime.ot;
        rawData.mobOutReg = mobOutTime.regular;
        rawData.mobReg += mobOutTime.regular;
        rawData.regular += mobOutTime.regular;
        rawData.mobOutOT = mobOutTime.ot;
        rawData.mobOT += mobOutTime.ot;
        rawData.ot += mobOutTime.ot;
        if(allOT){
            if(rawData.ot <= 2){
                rawData.data[lastNonLunchIndex].ot += 2 - rawData.ot;
                rawData.ot = 2;
            }else if(rawData.ot <= 4){
                rawData.data[lastNonLunchIndex].ot += 4 - rawData.ot;
                rawData.ot = 4;
            }else if(rawData.ot <= 6){
                rawData.data[lastNonLunchIndex].ot += 6 - rawData.ot;
                rawData.ot = 6;
            }else if(rawData.ot <= 8){
                rawData.data[lastNonLunchIndex].ot += 8 - rawData.ot;
                rawData.ot = 8;
            }
        }else{
            if(rawData.regular <= 2){
                rawData.data[lastNonLunchIndex].regular += 2 - rawData.regular;
                rawData.regular = 2;
            }else if(rawData.regular <= 4){
                rawData.data[lastNonLunchIndex].regular += 4 - rawData.regular;
                rawData.regular = 4;
            }else if(rawData.regular <= 6){
                rawData.data[lastNonLunchIndex].regular += 6 - rawData.regular;
                rawData.regular = 6;
            }else if(rawData.regular <= 8){
                rawData.data[lastNonLunchIndex].regular += 8 - rawData.regular;
                rawData.regular = 8;
            }
        }
    }
    return rawData;
}
export const calcEmergencyLocate = (
    curData: {
        data: any[], 
        workTime: number, 
        ot: number, 
        status: string,
        overnight: boolean
    }
) => {
    const rawData = curData;
    if(rawData.status !== "Submitted") return rawData;
    rawData.workTime = timeDurationCalc(rawData.data[rawData.data.length - 1].start, rawData.data[rawData.data.length - 1].end);
    if(rawData.overnight) rawData.workTime += 60 * 24;
    rawData.data = rawData.data.map(d => 
        ({...d, mins: timeDurationCalc(d.start, d.end) + d.shiftOvernight?60 * 24:0})
    );
    rawData.ot = 0;
    if(rawData.workTime <= 4 * 60){
        rawData.ot = 4;
    }else{
        rawData.ot = round(rawData.workTime / 60, 2); // no
    }

    return rawData;
}
// Components -----------------------------------------------------
export function OtherStyle({
    title, 
    others, 
    setOthers, 
    before
}:{
    title: string, 
    others: json, 
    setOthers: ss<json>
    before?: boolean
}){
    return(
        <>
        <div className = "d-flex align-items-center mb-2">
            <input
                id = {`${title}Others`}
                type = "checkbox"
                checked = {others[title] || false}
                value = "Others"
                className = {`checkboxSquare${before?" ms-3":""}`}
                onChange = {e => {
                    setOthers({...others, [title]:e.currentTarget.checked});
                }}
            />
            <label htmlFor = {`${title}Others`} className = "ms-2">Others</label>
        </div>
        {others[title]?
        <>
        <input
            key = {`${title}`}
            required
            placeholder = "Please specify"
            className = "form-control ms-3"
            name = {`${title}[]`}
            value = {others[`${title}Content`] || ""}
            onChange = {e => setOthers({...others, [`${title}Content`]:e.currentTarget.value})}
        />
        </>:null}
        </>
    ) 
}
export function MenuList({
    options, 
    children, 
    maxHeight, 
    getValue
}:{
    options: jsonArr, 
    children: [], 
    maxHeight: number, 
    getValue: Function
}
){
    const height = 35;
    const [value] = getValue(); // undefined
    const initialOffset = (options.indexOf(value) || 0) * height;
    return (
    <List
        height = {maxHeight}
        width = {""}
        style = {{whiteSpace: "nowrap"}}
        itemCount = {children.length || 0}
        itemSize = {height}
        initialScrollOffset = {initialOffset}
    >
        {({ index, style }) => <div style = {style}>{children[index]}</div>}
    </List>
    );
}
export function Select({...rest}){
    return (
        <div style = {rest.divStyle}>
            <OriginSelect
                components = {{MenuList} as any} // no idea
                styles = {{
                    menu: base => ({...base, zIndex: 2}),
                    container: base => ({
                    ...base,
                    flex: 1
                    })
                }}
                isClearable = {rest.isClearable ?? true}
                {...rest}
            />
            {rest.name?
            <input
                tabIndex = {-1}
                autoComplete = "off"
                style = {{ opacity: 0, height: 0 , position: "absolute"}}
                onFocus = {e => (e.currentTarget?.previousSibling?.childNodes?.[2]?.childNodes?.[0]?.childNodes?.[1]?.childNodes?.[0]! as HTMLInputElement).focus()}
                required = {rest.required ?? false}
                readOnly
                name = {rest.name}
                value = {
                    rest.isMulti?
                        (!rest.value || rest.value.length === 0?
                            ""
                            :
                            "undefined"
                        )
                        :
                        (rest.value?.value ?? "")
                }
            />
            :<></>}
        </div>
    );
}
export function FileInput({name, id, accept}:{name: string, id: string, accept: keyof mimeTypeMapType}){
    return <div className = "custom-file">
        <input
            type = "file"
            accept = {mimeTypeMap[accept] ?? ""}
            className = {"custom-file-input"}
            id = {id}
            name = {name}
            onChange = {handleFilesInput}
        />
        <label className = "custom-file-label">
            Choose file
        </label>
    </div>
}
//-----------------------------------------------------
export const outsideHolidays = (year: number) => [
    {date: `${year}-01-01`, name: "New Year's Day"}, 
    {date: getCustomDate(year, 0, 2, 1), name: "Martin Luther King Jr. Day"}, // 3rd Monday in January 
    // {date: getCustomDate(year, 1, 2, 1), name: "President's Day"}, // 3rd Monday in February
    {date: getCustomDate(year, 4, -1, 1), name: "Memorial Day"}, // Last Monday in May 
    {date: `${year}-07-04`, name: "Independence Day"}, 
    {date: getCustomDate(year, 8, 0, 1), name: "Labor Day"}, // 1st Monday in September 
    {date: `${year}-11-11`, name: "Veteran's Day"}, 
    {date: getCustomDate(year, 10, -1, 4), name: "Thanksgiving Day"}, // Last Thursday in November 
    {date: getCustomDate(year, 10, -1, 5), name: "Black Friday"}, // Day after Thanksgiving 
    {date: `${year}-12-24`, name: "Christmas Eve"}, 
    {date: `${year}-12-25`, name: "Christmas Day"}, 
    {date: `${year}-12-31`, name: "New Year's Eve"}
];
export const officeHolidays = (year: number) => [
    {date: `${year}-01-01`, name: "New Year's Day"}, 
    // {date: getCustomDate(year, 0, 2, 1), name: "Martin Luther King Jr. Day"}, // 3rd Monday in January 
    {date: getCustomDate(year, 1, 2, 1), name: "President's Day"}, // 3rd Monday in February
    {date: getCustomDate(year, 4, -1, 1), name: "Memorial Day"}, 
    {date: `${year}-07-04`, name: "Independence Day"}, 
    {date: getCustomDate(year, 8, 0, 1), name: "Labor Day"}, 
    // {date: `${year}-11-11`, name: "Veteran's Day"}, 
    {date: getCustomDate(year, 10, -1, 4), name: "Thanksgiving Day"}, 
    {date: getCustomDate(year, 10, -1, 5), name: "Black Friday"}, 
    {date: `${year}-12-24`, name: "Christmas Eve"}, 
    {date: `${year}-12-25`, name: "Christmas Day"}, 
    {date: `${year}-12-31`, name: "New Year's Eve"}
];

const stnadbyDurationOffset = 0;
const standbyTimeLength = 125;
export const standbyTP = timepicker({startIndex: stnadbyDurationOffset, timeLength: standbyTimeLength});
export const standbyReverseIndex = (str:string) => Math.max(0, standbyTP.findIndex(time => time.value === str));
export const standbyCalculate = (startIndex: number, endIndex: number, isOT: boolean) => {
    if(isOT) return {o: (endIndex - startIndex) * 0.25, s: 0};
    let s = 0, o = 0;
    if(
        (startIndex < 28 && endIndex <= 28) || /* s1e1 */
        (startIndex >= 62 && endIndex > 62) /* s3e3 */
    ){
        o += (endIndex - startIndex) * 0.25;
    }else if(
        startIndex >= 28 && endIndex <= 62 /* s2e2 */
    ){
        s += (endIndex - startIndex) * 0.25;
    }else if(
        startIndex <= 28 && endIndex >= 28 && endIndex <= 62/* s1e2 */
    ){
        o += (28 - startIndex) * 0.25;
        s += (endIndex - 28) * 0.25;
    }else if(
        startIndex >= 28 && startIndex <= 62 && endIndex >= 62 /* s2e3 */
    ){
        s += (62 - startIndex) * 0.25;
        o += (endIndex - 62) * 0.25;
    }else if(
        startIndex <= 28 && endIndex >= 62 /* s1e3 */
    ){
        o += (endIndex - startIndex - 34) * 0.25;
        s += 8.5;
    }
    return {o, s}
}

export const outsideDailydefaultEmptyData = JSON.stringify({
    form: Array(7).fill(
        {
            unlock: false, 
            working: "", 
            notWorkingReason: "", 
            commuteOrHotel: "", 
            division: "", 
            workingOn: "", 
            acknowledged: false, 
            morning: false, 
            afternoon: false,
            doOT: "", 
            otDate: "", 
            otTime: ""
        }
    ), status: "Created"
})

export const outsidePotDefaultEmptyData = JSON.stringify({
    unlock: false, 
    form: Array(7).fill({
        inYard: "", 
        outYard: ""
    }), status: "Created"
});

export const outsideEotDefaultEmptyData = JSON.stringify({
    unlock: false, 
    form: Array(7).fill({
        availablity: ""
    }), status: "Created"
});

export const getTimeStamp = () => (new MyDate()).s() + " " + (new MyDate()).ss();
export const standbyStartDate = "2023-07-17";
export const standbyWeeks = buildWeekNumArray(standbyStartDate).reverse();
export const locatorStartDate = "2021-08-29";
export const locatorWeeks = buildWeekNumArray(locatorStartDate).reverse();
export const officeTimeCardStartDate = "2021-06-07";
export const officeTimeCardWeeks = buildWeekNumArray(officeTimeCardStartDate).reverse();
export const fleetUsageStartStartDate = "2021-03-08";
export const fleetUsageStartWeeks = buildWeekNumArray(standbyStartDate).reverse();
export const defaultPath = "/opt/bitnami/apache/htdocs";
export const weekIndexes = [1, 2, 3, 4, 5, 6, 0];
export const plannedTimeExcel = (start:string, end:string, allDay:boolean) => {
    if(start.substring(0, 10) === end.substring(0, 10)){
        //same Day
        if(allDay){
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 10)}
            ]};
        }else{
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 10)},
                {"text": start.substring(10, 16) + " ~ " + end.substring(11, 16)}
            ]};
        }
    }else{
        //overnight
        if(allDay){
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 10)},
                {"text": " ~ "},
                {"font": {"bold": true},"text": end.substring(0, 10)},
            ]};
        }else{
            return {"richText": [
                {"font": {"bold": true},"text": start.substring(0, 16)},
                {"text": " ~ "},
                {"font": {"bold": true},"text": end.substring(0, 16)},
            ]};
        }
    }
}
export const assignemntSubmitTimeExcel = (e:string) => {
    return {"richText": [
        {"font": {"bold": true},"text": e.split(" ")[0]},
        {"text": " " + e.split(" ")[1]}
    ]};
}

export const validURL = (str:string) => {
    const pattern = new RegExp("^(https?:\\/\\/)?"+ // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|"+ // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))"+ // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*"+ // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?"+ // query string
        "(\\#[-a-z\\d_]*)?$","i"); // fragment locator
    return !!pattern.test(str);
}

export const GeotabApiOptions = {
    rememberMe: true, 
    timeout: 10,
    fullResponse: true
}
export const GeotabApiAuthentication = {
    credentials: {
        database: 'besstestlab',
        userName: 'jun@besstestlab.com',
        password: 'perfect909'
    },
    path: 'my.geotab.com'
}

export const getFileNameFromUrl = (fileUrl:string) => {
    const url = new URL(fileUrl);
    const params = new URLSearchParams(url.search);
    const contentDisposition = params.get("response-content-disposition");
    if(contentDisposition){
        const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^"]+)"?/);
        return match ? decodeURIComponent(match[1]) : null;
    }
  
    return url.pathname.split("/").pop();
};

export async function convertFilesFromHEICtoJPEG(files:File[]){
    return  await Promise.all(
        files.map(async (file) => {
        if (file.type === "image/heic") {
            let blob = await heic2any({ blob: file, toType: "image/jpeg" });
            if (Array.isArray(blob)) blob = blob[0];
            file = new File([blob], file.name.replace(/\.heic$/, ".jpg"), {
            type: "image/jpeg",
            });
        }
        return file;
        })
    );
}

export async function compressImage(file: File, purpose: string = "") {
  const options = {
    maxSizeMB: purpose === "profile"? 1: undefined, 
    maxWidthOrHeight: 2000, 
    useWebWorker: true, 
    initialQuality: 0.85, 
    onProgress: (progress:number) => {
        console.log(`compressing: ${progress}%`);
    }
  };

  try {
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.error("Compression error:", error);
    return file;
  }
}
export type OS = "mac" | "windows" | "other";
export function detectOS(): OS {
  // 1️⃣ Modern Chromium (no deprecation)
  const uaData = navigator.userAgentData;
  if (uaData?.platform) {
    if (uaData.platform === "macOS") return "mac";
    if (uaData.platform === "Windows") return "windows";
  }
  // 2️⃣ Cross-browser fallback (deprecated but unavoidable)
  const platform = navigator.platform.toLowerCase();
  if (platform.includes("mac")) return "mac";
  if (platform.includes("win")) return "windows";
  return "other";
}
export function getCurrentWeekRange() {
    const today = new Date();
    const day = today.getDay(); // 0 = Sun, 1 = Mon
    // Calculate Monday
    const monday = new Date(today);
    monday.setDate(today.getDate() - (day === 0 ? 6 : day - 1));
    // Calculate Sunday
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    const fmt = (d: Date) => d.toISOString().slice(0, 10);
    return {
    start: fmt(monday),
    end: fmt(sunday)
    };
}
export const getISOYearWeek = (): string => {
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    const week = Math.ceil((((date.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
    const year = date.getUTCFullYear();
    return `${year}${String(week).padStart(2, "0")}`;
};
